// extracted by mini-css-extract-plugin
export default {"searchBar":"Search_searchBar__xcwv8","btnSearch":"Search_btnSearch__7yPMz","input":"Search_input__yqwW2","search":"Search_search__EgW03","fade":"Search_fade__gj2nk"};